module.exports = __webpack_public_path__ + "img/skywrath_mage.be0f6fca.png";